/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import {
  ApduRequest,
  ApduResponse,
  TapRequestEncrypted,
  TapApduRequest,
  TapEncryptedFrame,
  TapRequestFrame,
  TapResponseFrame,
} from '@iotize/tap/client/api';
import {
  TapStreamReader,
  TapStreamWriter,
  enumKeyOrValueToNumber,
} from '../frame/tap-stream-core';

export class ApduRequestConverter implements BodyConverter<ApduRequest> {
  public encode(
    model: ApduRequest,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeApduRequest(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ApduRequest {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readApduRequest();
  }
}

export class ApduResponseConverter implements BodyConverter<ApduResponse> {
  public encode(
    model: ApduResponse,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeApduResponse(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ApduResponse {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readApduResponse();
  }
}

export class TapRequestEncryptedConverter
  implements BodyConverter<TapRequestEncrypted>
{
  public encode(
    model: TapRequestEncrypted,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeTapRequestEncrypted(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): TapRequestEncrypted {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readTapRequestEncrypted();
  }
}

export class TapApduRequestConverter implements BodyConverter<TapApduRequest> {
  public encode(
    model: TapApduRequest,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeTapApduRequest(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): TapApduRequest {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readTapApduRequest();
  }
}

export class TapEncryptedFrameConverter
  implements BodyConverter<TapEncryptedFrame>
{
  public encode(
    model: TapEncryptedFrame,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeTapEncryptedFrame(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): TapEncryptedFrame {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readTapEncryptedFrame();
  }
}

export class TapRequestFrameConverter
  implements BodyConverter<TapRequestFrame>
{
  public encode(
    model: TapRequestFrame,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeTapRequestFrame(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): TapRequestFrame {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readTapRequestFrame();
  }
}

export class TapResponseFrameConverter
  implements BodyConverter<TapResponseFrame>
{
  public encode(
    model: TapResponseFrame,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeTapResponseFrame(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): TapResponseFrame {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readTapResponseFrame();
  }
}
